import { defineProvider } from '@nuxt/image/runtime'
import storyblok from '@nuxt/image/runtime/providers/storyblok'

// Storyblok images are resized by Storyblok's image service and served from its CDN.
// Anything else (files in public/) is served as it is, so the server never processes images.
export default defineProvider({
  getImage: (src, context) => src.startsWith('https://a.storyblok.com/')
    ? storyblok().getImage(src, context)
    : { url: src }
})
